import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.mobile-numbers.recovery-settings', {
        url: '/recovery-settings',
        component: 'recoverySettings',
        resolve: {recoverySettingsData}
    });
}

/** @ngInject */
function recoverySettingsData(DestructiveOperationModal) {
    return DestructiveOperationModal({
        textKey: 'destructive_operation.enter_onetime_password_text',
        http: {method: 'GET', url: 'app/rest/recovery'}
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/recovery-settings/recovery-settings.state.js